function initEmptyDrawerStates(root = document) {
  const blocks = root.querySelectorAll("[data-empty-drawer-state]");

  blocks.forEach((block) => {
    if (block.dataset.emptyDrawerInitialized === "true") return;

    // DN 2026-07-30 (perf): don't build the illustration while its drawer is
    // closed or the empty state is hidden, otherwise the image downloads on
    // every page load even when nobody sees it. Skip (leaving the block
    // uninitialized) when it sits inside a closed offcanvas drawer or a hidden
    // container. Every reveal path re-runs init once it is actually on screen:
    // shown.bs.offcanvas (cart + wishlist drawers), the #offcanvas-wishlist-empty
    // hidden-attribute observer, and the predictive-search observer. Inline empty
    // states (e.g. the wishlist page) are not inside either, so they still init
    // on load.
    if (block.closest(".offcanvas:not(.show)") || block.closest("[hidden]")) return;

    const raw = block.getAttribute("data-images");
    if (!raw) return;

    let items = [];

    try {
      items = JSON.parse(raw);
    } catch (e) {
      return;
    }

    items = items.filter((item) => item && item.src);

    if (!items.length) return;

    const mediaWrap = block.querySelector("[data-empty-drawer-media]");
    if (!mediaWrap) return;

    const chosen = items[Math.floor(Math.random() * items.length)];

    const img = document.createElement("img");
    img.alt = chosen.alt || "";
    img.loading = "eager";
    img.className = "empty-drawer-state__image";
    mediaWrap.hidden = false;

    img.addEventListener("load", () => {
      mediaWrap.hidden = false;
    });

    img.addEventListener("error", () => {
      img.remove();
      mediaWrap.hidden = true;
    });

    img.src = chosen.src;

    if (chosen.href) {
      const link = document.createElement("a");
      link.href = chosen.href;
      link.className = "empty-drawer-state__image-link";
      link.appendChild(img);
      mediaWrap.appendChild(link);
    } else {
      mediaWrap.appendChild(img);
    }

    if (img.complete && img.naturalWidth > 0) {
      mediaWrap.hidden = false;
    }

    block.dataset.emptyDrawerInitialized = "true";
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initEmptyDrawerStates();

  const wishlistEmpty = document.querySelector("#offcanvas-wishlist-empty");
  if (wishlistEmpty) {
    const observer = new MutationObserver(() => {
      initEmptyDrawerStates(wishlistEmpty);
    });

    observer.observe(wishlistEmpty, {
      attributes: true,
      attributeFilter: ["hidden"],
    });
  }

  const predictiveSearch = document.querySelector("#predictive-search");

  if (predictiveSearch) {
    const observer = new MutationObserver(() => {
      initEmptyDrawerStates(predictiveSearch);
    });

    observer.observe(predictiveSearch, {
      childList: true,
      subtree: true,
    });
  }
});

document.addEventListener("shown.bs.offcanvas", function (event) {
  initEmptyDrawerStates(event.target);
});

window.addEventListener("updated.ecomify.cart", function () {
  initEmptyDrawerStates(document.querySelector("#offcanvas-cart") || document);
});
